export const DATE_FORMAT = 'DD.MM.YYYY';
export const TIME_FORMAT = 'H:mm';
